export enum ApiAdminSiteManager {
  GET_ALL_SITES = 'admin/site/me',

  GET_ALL_SITES_V2 = 'admin/site/v2/me',

  GET_ONE_SITE = 'admin/site/',

  ADD_NEW_SITE = 'admin/site',

  SOCIAL_MEDIA_CONFIG = '/social-media',

  SITE_SETTING = 'admin/site/setting/',

  SITE_CURRENCY = '/currency',

  SITE_LANGUAGE = '/language',

  AVAILABLE_PAYMENT_METHODS = 'available-payment-methods',

  AVAILABLE_ADS_PIXEL = 'available-ads-pixel',

  ADS_PIXEL = '/ads-pixel',

  GOOGLE_ANALYTICS = '/analytics',

  PAYMENT_METHODS = '/payment-methods',

  SHIPPING_METHODS = '/shipping-methods',

  SHOP_INFO = '/info',

  VALIDATE_SHOP = 'admin/site/validate-site-name',

  CUSTOM_DOMAIN = '/custom-domain',

  STATUS = '/status',

  // POS Endpoints
  POS_STORE = '/pos/store',
  POS_STAFF = '/pos/staff',
  POS_TERMINALS = '/pos/terminals',
  POS_PAYMENT_METHODS = '/pos/payment-methods',
  POS_TICKET_CONFIG = '/pos/ticket-config',
  POS_ACTIVATE = '/pos/activate',
  POS_DEACTIVATE = '/pos/deactivate',
  POS_CASH_SESSIONS = '/pos/cash-sessions',
  POS_STOCK_FAILURES = '/pos/stock-failures'
}
